import React from 'react';
import Navbar from '../components/Navbar';
import ConsultantsHero from '../components/consultants/ConsultantsHero';
import ConsultantsProblem from '../components/consultants/ConsultantsProblem';
import WhyTraainConsultants from '../components/consultants/WhyTraainConsultants';
import WhiteLabelBenefits from '../components/consultants/WhiteLabelBenefits';
import TrainingIntelligenceConsultants from '../components/consultants/TrainingIntelligenceConsultants';
import RolePlayIntelligenceConsultants from '../components/consultants/RolePlayIntelligenceConsultants';
import ExchangeConsultants from '../components/consultants/ExchangeConsultants';
import MediaProduction from '../components/consultants/MediaProduction';
import ConsultantsKPIs from '../components/consultants/ConsultantsKPIs';
import ConsultantsCTA from '../components/consultants/ConsultantsCTA';
import Footer from '../components/Footer';

const ConsultantsPage = () => {
  return (
    <div className="min-h-screen bg-gray-950 text-white">
      {/* Animated Background */}
      <div className="fixed inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-950 via-gray-900 to-purple-950 animate-gradient" />
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 left-0 w-96 h-96 bg-indigo-500 rounded-full filter blur-3xl animate-blob" />
          <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500 rounded-full filter blur-3xl animate-blob animation-delay-2000" />
          <div className="absolute bottom-0 left-1/2 w-96 h-96 bg-blue-600 rounded-full filter blur-3xl animate-blob animation-delay-4000" />
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <ConsultantsHero />
        <ConsultantsProblem />
        <WhyTraainConsultants />
        <WhiteLabelBenefits />
        <TrainingIntelligenceConsultants />
        <RolePlayIntelligenceConsultants />
        <ExchangeConsultants />
        <MediaProduction />
        <ConsultantsKPIs />
        <ConsultantsCTA />
        <Footer />
      </div>
    </div>
  );
};

export default ConsultantsPage;
